exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-menu{position:relative;margin-bottom:24px;display:block;width:100%;z-index:9999}.autocomplete-menu .md-field{margin-bottom:1px}.autocomplete-menu .md-button-clean{overflow:visible!important}.autocomplete-menu-content{position:absolute;left:0;right:0;bottom:0;transform:translateY(100%);padding:0;overflow-y:scroll;max-height:400px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cc07a8e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Autocomplete.vue
// module id = 368
// module chunks = 0